import React from 'react'
import styled from 'styled-components'
import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import colors from 'theme/colors'
import fonts from 'theme/fonts'
import breakpoints from 'theme/breakpoints'
import { Column } from 'styled/alignment/Column'
import { Eye } from 'react-feather'

function CertificatePreview({ visible, onClose, contentHtml, layoutType, backgroundImage }) {
    const isCustom = layoutType === 'custom'

    return (
        <Modal
            isOpen={visible}
            onClose={onClose}
            size='large'
            closeButton
        >
            <Column>
                <HeaderRow>
                    <IconBox><Eye size={18} color={colors.occasionalPurple} /></IconBox>
                    <div>
                        <Text name='highlight' type='bold' color={colors.nightDark} paddingBottom={0}>
                            Pré-visualização
                        </Text>
                        <Text name='small' color={colors.night} paddingBottom={0}>
                            Confira como o certificado será exibido para os participantes.
                        </Text>
                    </div>
                </HeaderRow>

                <PreviewArea>
                    <CertificateSheet isCustom={isCustom} backgroundImage={backgroundImage}>
                        {!isCustom && <CertificateBorder />}
                        <CertificateContent
                            dangerouslySetInnerHTML={{ __html: contentHtml }}
                        />
                    </CertificateSheet>
                </PreviewArea>

                <FooterRow>
                    <CloseButton type="button" onClick={onClose}>
                        Fechar
                    </CloseButton>
                </FooterRow>
            </Column>
        </Modal>
    )
}

export default CertificatePreview

const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
`

const IconBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #F3EAFF;
    flex-shrink: 0;
`

const PreviewArea = styled.div`
    padding: 24px;
    background: ${colors.neutralBackground};
    border: 1px solid ${colors.neutralDark};
    border-radius: 10px;
    display: flex;
    justify-content: center;
`

const CertificateSheet = styled.div`
    position: relative;
    width: 100%;
    max-width: 640px;
    aspect-ratio: 1.414 / 1;
    background: ${({ isCustom, backgroundImage }) =>
        isCustom && backgroundImage
            ? `url(${backgroundImage}) center/cover no-repeat`
            : colors.neutralLight
    };
    border: 1px solid ${colors.neutralDark};
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
`

const CertificateBorder = styled.div`
    position: absolute;
    inset: 16px;
    border: 2.5px solid ${colors.primaryLight};
    border-radius: 4px;
    pointer-events: none;
    opacity: 0.25;

    &::after {
        content: '';
        position: absolute;
        inset: 5px;
        border: 1.5px solid ${colors.primaryLight};
        border-radius: 2px;
        opacity: 0.6;
    }
`

const CertificateContent = styled.div`
    position: relative;
    z-index: 1;
    width: 78%;
    max-height: 82%;
    overflow: auto;
    text-align: center;
    padding: 24px;

    h1, h2, h3 { margin: 8px 0; }
    p {
        margin: 5px 0;
        font-size: ${fonts.sizes.small};
        line-height: 1.6;
    }
    strong { font-weight: bold; }

    @media screen and (min-width: ${breakpoints.lg}) {
        p { font-size: ${fonts.sizes.default}; }
    }
`

const FooterRow = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
`

const CloseButton = styled.button`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 20px;
    border: none;
    border-radius: 8px;
    background: #F3EAFF;
    color: ${colors.occasionalPurple};
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all .2s ease;

    &:hover {
        background: #E8D5FF;
    }
`
